(function () {
var $090807b6954155da$var$storageName = 'batteryWarning', $090807b6954155da$var$batteryThreshold = 0.12, $090807b6954155da$var$batteryCheckDelayInSeconds = 20, $090807b6954155da$var$closeToggleDelayInSeconds = 1.5;
var $090807b6954155da$var$batteryCheckInterval;
var $090807b6954155da$var$batteryHasEventListener = false;
var $090807b6954155da$var$elements = {
    batteryModal: function() {
        return document.querySelector('#battery-low');
    },
    batteryCloser: function() {
        return document.querySelector('#battery-low header button');
    },
    batteryToggle: function() {
        return document.querySelector('#battery-low footer .form-binary-input');
    }
};
var $090807b6954155da$var$batteryModal = $090807b6954155da$var$elements.batteryModal();
var $090807b6954155da$var$batteryCloser = $090807b6954155da$var$elements.batteryCloser();
var $090807b6954155da$var$batteryToggle = $090807b6954155da$var$elements.batteryToggle();
if (!$090807b6954155da$var$batteryModal || !$090807b6954155da$var$batteryCloser) throw new Error('Battery modal elements are missing');
var $090807b6954155da$var$classNames = {
    show: 'battery--show'
};
var $090807b6954155da$var$isVisible = function() {
    return $090807b6954155da$var$batteryModal.classList.contains($090807b6954155da$var$classNames.show);
};
var $090807b6954155da$var$show = function() {
    if ($090807b6954155da$var$isVisible()) return;
    $090807b6954155da$var$batteryModal.classList.add($090807b6954155da$var$classNames.show);
    // Send event to data layer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'lowBatteryShow'
    });
};
var $090807b6954155da$var$hide = function() {
    var continueChecking = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (!continueChecking) clearInterval($090807b6954155da$var$batteryCheckInterval);
    $090807b6954155da$var$batteryModal.classList.remove($090807b6954155da$var$classNames.show);
};
var $090807b6954155da$var$checkBatteryStatus = function() {
    if (!navigator.getBattery) return;
    navigator.getBattery().then(function(battery) {
        if (!battery.charging && battery.level < $090807b6954155da$var$batteryThreshold) {
            $090807b6954155da$var$show();
            if (!$090807b6954155da$var$batteryHasEventListener) {
                battery.addEventListener('chargingchange', function() {
                    if (battery.charging && $090807b6954155da$var$isVisible()) $090807b6954155da$var$hide(true);
                });
                $090807b6954155da$var$batteryHasEventListener = true;
            }
        }
    }).catch(function(error) {
        console.error('Battery status check failed', error);
        clearInterval($090807b6954155da$var$batteryCheckInterval);
    });
};
var $090807b6954155da$var$runBatteryCheck = function() {
    if (navigator.getBattery && !localStorage.getItem($090807b6954155da$var$storageName) && !sessionStorage.getItem($090807b6954155da$var$storageName)) $090807b6954155da$var$batteryCheckInterval = setInterval($090807b6954155da$var$checkBatteryStatus, $090807b6954155da$var$batteryCheckDelayInSeconds * 1000);
};
/**
 * Closing the battery warning
 */ // 1. When the close button is clicked the battery warning should be hidden and not shown again for the current session
$090807b6954155da$var$batteryCloser.addEventListener('click', function() {
    sessionStorage.setItem($090807b6954155da$var$storageName, String(false));
    $090807b6954155da$var$hide();
});
// 2. When the toggle is clicked the battery warning should be hidden and not shown again as long as the local storage is not cleared
$090807b6954155da$var$batteryToggle === null || $090807b6954155da$var$batteryToggle === void 0 ? void 0 : $090807b6954155da$var$batteryToggle.addEventListener('change', function() {
    setTimeout(function() {
        localStorage.setItem($090807b6954155da$var$storageName, String(false));
        $090807b6954155da$var$hide();
    }, $090807b6954155da$var$closeToggleDelayInSeconds * 1000);
});
$090807b6954155da$var$runBatteryCheck();
// Expose function to show battery warning message
window.showBatteryLowMessage = $090807b6954155da$var$show;

})();
//# sourceMappingURL=battery.min.js.map
